import React from 'react';
import { useSafeImageSrc } from './useSafeImageSrc';

/**
 * Image that verifies `src` loads before showing it, falling back to `altSrc` otherwise.
 * Renders nothing when there is no URL to show (see `useSafeImageSrc`).
 *
 * @param {Object} props
 * @param {string} props.src - Preferred image URL.
 * @param {string} [props.altSrc] - Fallback URL shown while `src` is being checked or if it fails to load.
 * @param {string} [props.className] - Class name(s) for the `<img>`.
 * @param {number|string} [props.width] - Width attribute of the `<img>`.
 * @param {number|string} [props.height] - Height attribute of the `<img>`.
 * @param {React.MouseEventHandler<HTMLImageElement>} [props.onClick] - Click handler for the `<img>`.
 * @param {React.CSSProperties} [props.style] - Inline style for the `<img>`.
 * @returns {JSX.Element|null}
 */
const SafeImage = props => {
    const {src, altSrc, className = '', width, height, onClick, style} = props,
        checkedSrc = useSafeImageSrc(src, altSrc);

    if (!checkedSrc) return null;

    return <img src={checkedSrc} className={className} style={style} width={width} height={height} onClick={onClick} />;
};

export default SafeImage;


